export function startDateDelta(startDate, nextStartDate, fullDate, nextEndDate) {
  var inStartDateDelta;
  if (nextStartDate !== startDate) {
    var startDateDelta_1 = [startDate, nextStartDate].sort();
    inStartDateDelta = fullDate >= startDateDelta_1[0] && fullDate <= (nextEndDate || startDateDelta_1[1]);
  }
  return inStartDateDelta;
}
export function endDateDelta(endDate, nextEndDate, fullDate, nextStartDate) {
  var inEndDateDelta;
  if (nextEndDate !== endDate) {
    var endDateDelta_1 = [endDate, nextEndDate || nextStartDate].sort();
    inEndDateDelta = fullDate >= endDateDelta_1[0] && fullDate <= endDateDelta_1[1];
  }
  return inEndDateDelta;
}
export function hoveredDateDelta(hoveredDate, nextHoveredDate, fullDate) {
  var inHoveredDateDelta = false;
  if (nextHoveredDate !== hoveredDate) {
    var hoveredDateDelta_1 = [hoveredDate, nextHoveredDate].sort();
    inHoveredDateDelta = fullDate >= hoveredDateDelta_1[0] && fullDate <= hoveredDateDelta_1[1];
  }
  return inHoveredDateDelta;
}
export function fullDateChanged(fullDate, nextFullDate) {
  return fullDate !== nextFullDate;
}
export function selectableDateDelta(maxSelectableDate, nextMaxSelectableDate, fullDate) {
  var inSelectableDateDelta = false;
  if (nextMaxSelectableDate !== maxSelectableDate) {
    var selectableDateDelta_1 = [maxSelectableDate, nextMaxSelectableDate].sort();
    inSelectableDateDelta = fullDate >= selectableDateDelta_1[0] && fullDate <= selectableDateDelta_1[1];
  }
  return inSelectableDateDelta;
}